import styled from 'styled-components'
import {
  COLOR,
  FONT_SIZE,
  BUTTON_SIZE,
  Z_INDEXS,
} from '../../../themes'
const padding = 70
export const StyleModal = styled.div`
  .sub-content {
    padding: 60px;
  }
  .content-Modal{
    border-radius: 8px;
    z-index: ${Z_INDEXS.LV_6};
    color: ${COLOR.BLACK_1};
    display: block;
    position: fixed;
    background: #FFF;
    top: 20%;
    height: 420px;
    width: ${660 - padding}px;
    font-size: ${FONT_SIZE.SM};
    padding-left: ${padding}px;
    padding-right: ${padding}px;
    text-align: center;
    left: 0;
    right: 0;
    margin: auto;
    -webkit-animation-name: example; /* Safari 4.0 - 8.0 */
    -webkit-animation-duration: 0.5s; /* Safari 4.0 - 8.0 */
    animation-name: example;
    animation-duration: 0.5s;
  }


  /* Safari 4.0 - 8.0 */
  @-webkit-keyframes example {
    0%   {
      padding-left: 30px;
      padding-right: 30px;
    }
    100%  {
      padding-left: ${padding}px;
      padding-right: ${padding}px;
    }
  }

  /* Standard syntax */
  @keyframes example {
    0%   {
      padding-left: 30px;
      padding-right: 30px;
    }
    100%  {
      padding-left: ${padding}px;
      padding-right: ${padding}px;
    }
  }

  .head-modal{
    font-size: ${FONT_SIZE.XXL};
    font-weight: bold;
    letter-spacing: 1px;
  }

  .description{
    margin-top: 30px;
    font-size: ${FONT_SIZE.XS};
    color: ${COLOR.BLACK_1};
  }

  .input-delete{
    margin-top: 50px;
    border: none;
    width: 100%;
    outline: none;
    border-bottom: 1px solid ${COLOR.BLACK_1};
    font-size: ${FONT_SIZE.XS};
    padding-bottom: 6px;
    ::placeholder {
      font-size: ${FONT_SIZE.XS};
      color: ${COLOR.GRAY_3}

    }
  }

  .modal-btn-delete, .modal-btn-keep{
    width: 196px;
    margin-top: 30px;
    font-size: ${FONT_SIZE.XXS};
    line-height:${BUTTON_SIZE.LINE_HEIGHTS.MD};
    border: 1px solid ${COLOR.GRAY_6};
    background: ${COLOR.WHITE};
    float: none;
    color: ${COLOR.BLACK_1};
  }

  .modal-btn-delete{
    border: 1px solid ${COLOR.RED_1};
    background: ${COLOR.RED_1};
    margin-left: 10px;
    color: ${COLOR.WHITE};
    cursor: not-allowed;
  }

  .is-pass{
    border: 1px solid ${COLOR.RED_2};
    background: ${COLOR.RED_2};
    cursor: pointer;
  }

  .text-error{
    margin-top: 10px;
    font-size: ${FONT_SIZE.TN};
    color: ${COLOR.RED_2};
  }

`
